import { Link } from "react-router-dom";
import { Button } from "../../components/ui/button";
import {
  Calendar,
  Phone,
  MapPin,
  Clock,
  Star,
  Award,
  Heart,
  Shield,
  Building2,
  Package,
  Stethoscope,
  PlusCircle,
  Baby,
  Bone,
  Brain,
  Microscope,
  ChevronRight,
  Download,
  CheckCircle,
  Trophy,
  BadgeIcon as Certificate,
  User,
  ArrowRight,
} from "lucide-react"
import { Badge } from "../ui/badge"

export default function Aboutuswidget() {
  return (
    <section className="py-12 bg-gray-100">
          <div className="container px-4 mx-auto">
            <div className="flex flex-col items-center max-w-3xl mx-auto text-center">
              <Badge className="mb-4">About Us</Badge>
              <h2 className="mb-4 text-3xl font-bold md:text-4xl">Committed to Excellence in Healthcare</h2>
              <p className="mb-6 text-lg text-muted-foreground">
                Pranaam Hospitals is dedicated to providing exceptional healthcare services with a focus on patient
                comfort, advanced medical technology, and compassionate care. With multiple branches across Hyderabad
                and surrounding areas, we bring quality healthcare closer to you.
              </p>
              <div className="flex flex-wrap justify-center gap-4 mt-2">
                <Badge variant="outline" className="px-3 py-1">
                  <Clock className="w-4 h-4 mr-1" />
                  24/7 Emergency Services
                </Badge>
                <Badge variant="outline" className="px-3 py-1">
                  <Stethoscope className="w-4 h-4 mr-1" />
                  Expert Specialists
                </Badge>
                <Badge variant="outline" className="px-3 py-1">
                  <Microscope className="w-4 h-4 mr-1" />
                  Advanced Diagnostics
                </Badge>
                <Badge variant="outline" className="px-3 py-1">
                  <Star className="w-4 h-4 mr-1" />
                  NABH Accredited
                </Badge>
              </div>
              <Button variant="link" className="mt-6 gap-2 text-primary" asChild>
                <Link to="/about">
                  Learn More About Us
                  <ChevronRight className="w-4 h-4" />
                </Link>
              </Button>
            </div>
          </div>
        </section>
  );
}
